import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import $ from "jquery";
import { Link } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { CKEditor } from 'ckeditor4-react';
import BigNumber from "bignumber.js";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import * as myConstList from "../../../BaseUrl";
const baseUrl = myConstList.baseUrl;
class MarketTrade extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      leaderboard: [],
      virtualFund: 0,
      contestType: this.props.contestType,
    };

    var classThis = this;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.leaderboard) {
      this.setState({ leaderboard: nextProps.leaderboard });
    }
    if (nextProps.virtualFund) {
      this.setState({ virtualFund: nextProps.virtualFund });
    }
    if (nextProps.contestType) {
      this.setState({ contestType: nextProps.contestType });
    }
  }

  showLeatherBoardHtml = () => {
    var html = [];
    var rank = 0;
    var profitArr = [];
    var virtualFund = this.props.virtualFund;
    function redactEmail(email) {
      const atIndex = email.indexOf("@");
      if (atIndex !== -1) {
        const domainIndex = email.indexOf(".", atIndex);
        const domain = email.slice(domainIndex);
        const username = email.slice(0, Math.min(3, atIndex));
        const redactedUsername = "*".repeat(atIndex - 3);
        return `${username}${redactedUsername}@${domain}`;
      } else {
        return email;
      }
    }

    this.state.leaderboard.map(function (value, i) {
      // console.log("value===",value);
      if (value.order_count >= 1) {
        var rowColorLeader =
          virtualFund >= value.portfoliovalue ? "#eb6a61" : "#01aa78";
        var portfolioVal = value.portfoliovalue;

        if (profitArr.includes(portfolioVal) === false) {
          rank++;
        }
        profitArr.push(portfolioVal);

        html.push(
          <tr style={{ color: rowColorLeader }}>
            <td>
              <span className="pr-2">{rank}</span>
            </td>
            <td>
              <span className="pr-2">{value.name}</span>
            </td>
            <td>
              <span className="pr-2">
                {value.mobile === ""
                  ? redactEmail(value.email)
                  : value.mobile.replace(/\d(?=\d{4})/g, "*")}
              </span>
            </td>
            <td>
              <span className="pr-2">{value.per.toFixed(3) + "%"}</span>
            </td>
          </tr>
        );
        //console.log("profitArr.includes(portfolioVal)",profitArr.includes(portfolioVal));
      }
    });
    return html;
  };

  showParticipantsHtml = () => {
    var html = [];
    // console.log("this.state.leaderboard.length=",this.state.leaderboard.length)
    function redactEmail(email) {
      const atIndex = email.indexOf("@");
      if (atIndex !== -1) {
        const domainIndex = email.indexOf(".", atIndex);
        const domain = email.slice(domainIndex);
        const username = email.slice(0, Math.min(3, atIndex));
        const redactedUsername = "*".repeat(atIndex - 3);
        return `${username}${redactedUsername}@${domain}`;
      } else {
        return email;
      }
    }
    if (this.state.leaderboard.length > 0) {
      this.state.leaderboard.map(function (value, i) {
        var rowColor = value.order_count >= 1 ? "#01aa78" : "#eb6a61";
        html.push(
          <tr style={{ color: rowColor }}>
            <td className="col-3 ">{i + 1}</td>
            <td className="col-3 ">{value.name}</td>
            <td className="col-3 ">
              {value.mobile === ""
                ? redactEmail(value.email)
                : value.mobile.replace(/\d(?=\d{4})/g, "*")}
            </td>
            {/* <td className="col-3 "></td> */}
            <td className="col-3 ">
              {value.portfoliovalue ? value.portfoliovalue.toFixed(2) : ""}
            </td>
            <td className="col-3 tr">{value.order_count}</td>
          </tr>
        );
      });
    }
    return html;
  };

  tabClick(tabType) {
    const { user } = this.props.auth;
    window.webengage.track("Live Contest Category Viewed", {
      "Category Name": tabType,
      "Phone number": user.mobile,
      Name: user.name,
    });
  }

  render() {
    return (
      <div className="crypt-market-status mt-2 ">
        <div>
          {this.state.contestType !== "price" &&
            this.state.contestType !== "coin" && (
              <ul className="nav nav-tabs nav-tabs5" id="crypt-tab">
                {/*<li role="presentation"><a className="active show" href="#MarketTrades"
				data-toggle="tab" className="">Market Trades</a></li>*/}

                <li role="presentation">
                  <a
                    className="active show"
                    href="#MarketTrades"
                    data-toggle="tab"
                    onClick={() => this.tabClick("Leaderboard")}
                  >
                    Leaderboard
                  </a>
                </li>
                <li role="presentation">
                  <a
                    href="#MarketTradesParticipants"
                    data-toggle="tab"
                    onClick={() => this.tabClick("Participants")}
                  >
                    Participants
                  </a>
                </li>
                {/* <li role="presentation"><a href="#MyTrades" data-toggle="tab">My Trades</a></li>*/}
              </ul>
            )}
          <div className="tab-content crypt-tab-content">
            <div
              role="tabpanel"
              className="tab-pane active show"
              id="MarketTrades"
            >
              <div className="table-overflow mb-2">
                <div className="table-responsive">
                  <table className="table border_none mb-0">
                    <thead>
                      <tr>
                        {/* <th className="col-4">Price(USDT)</th>
                                            <th className="col-4">Amount({props.curruncyName})</th>

                                        <th className="col-4 tr">Time</th>*/}
                        <th className="col-4">Rank</th>
                        <th className="col-4">User</th>
                        <th className="col-4">Mobile/Email ID</th>
                        {/*<th className="col-4">Value</th>*/}
                        <th className="col-4">Gain/Loss %</th>
                      </tr>
                    </thead>
                    <tbody className="crypt-table-hover">
                      {this.showLeatherBoardHtml()}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div
              role="tabpanel"
              className="tab-pane"
              id="MarketTradesParticipants"
            >
              <div className="table-overflow mb-2">
                <div className="table-responsive">
                  <table className="table border_none mb-0">
                    <thead>
                      <tr>
                        {/* <th className="col-4">Price(USDT)</th>
                                    <th className="col-4">Amount({props.curruncyName})</th>

								<th className="col-4 tr">Time</th>*/}
                        <th className="col-3">Sr No.</th>
                        <th className="col-3">User</th>
                        <th className="col-3">Mobile/Email ID</th>
                        <th className="col-3">Value</th>

                        <th className="col-3 tr">No of Transactions</th>
                      </tr>
                    </thead>
                    <tbody className="crypt-table-hover">
                      {this.showParticipantsHtml()}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/*<div role="tabpanel" className="tab-pane" id="MyTrades">
                        <table className="table border_none mb-0">
                            <thead>
                                <tr>
                                    <th className="col-4">Price(USDT)</th>
                                    <th className="col-4">Amount({props.curruncyName})</th>

                                    <th className="col-4 tr">Time</th>
                                </tr>
                            </thead>
                        </table>
                        <div className="table-overflow mb-2">

                            <table className="table border_none mb-0">
                                <tbody className="crypt-table-hover">


                                    {html}

                                </tbody>
                            </table>
                        </div>
                    </div>
					*/}
          </div>
        </div>
      </div>
    );
  }
}

MarketTrade.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});
export default connect((state) => state)(withRouter(MarketTrade));
